export const isDatadog = () => {
  return navigator.userAgent === "DatadogSynthetics";
};
